// These values are loaded separately by lists/checklist views and may be absent
// from the Job mutation response. All other fields belong to the latest snapshot.
const ENRICHMENT_FIELDS = [
    'id', 'region', 'task_subtype', 'related_work', 'guest_key_type', 'property_next_job_date',
    'unarranged_reports', 'unarranged_deep_clean_reports',
    'images_count', 'req_fix_count', 'req_deep_clean_count', 'req_key_count',
    'open_issue_count', 'blocked_issue_count',
    'checklists', 'removed_checklists', 'checklist_revision', 'checklist_total', 'checklist_completed',
    'has_job_level_checklist', 'has_property_level_checklist',
];

export function replaceJobSnapshot(previous, snapshot) {
    const result = {...snapshot};
    for (const field of ENRICHMENT_FIELDS) {
        if (!Object.hasOwn(snapshot, field) && Object.hasOwn(previous, field)) {
            result[field] = previous[field];
        }
    }
    return result;
}
